import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TokenJWT } from 'src/app/core/models/token/tokenJWT';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private tokenSubject: BehaviorSubject<TokenJWT | undefined> =
    new BehaviorSubject<TokenJWT | undefined>(undefined);

  constructor() {}

  getToken(): Observable<TokenJWT | undefined> {
    return this.tokenSubject.asObservable();
  }

  async setToken(token: TokenJWT | undefined): Promise<void> {
    this.tokenSubject.next(token);
  }

  async clearToken(): Promise<void> {
    this.tokenSubject.next(undefined);
  }
}
